// Central content + assets for Scott Whitty's portfolio.

export const IMAGES = {
  scott: "/scott-portrait.png",
  heroTexture:
    "https://images.unsplash.com/photo-1608501821300-4f99e58bba77?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHxhYnN0cmFjdCUyMGZsdWlkJTIwZGFyayUyMHRleHR1cmV8ZW58MHx8fHwxNzgzOTg4MjU1fDA&ixlib=rb-4.1.0&q=85",
  software:
    "https://images.unsplash.com/photo-1651505942687-efc26cb528ba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwzfHxmdXR1cmlzdGljJTIwaW50ZXJmYWNlJTIwZGFzaGJvYXJkfGVufDB8fHx8MTc4Mzk4ODI0OXww&ixlib=rb-4.1.0&q=85",
  anatomy:
    "https://images.unsplash.com/photo-1781804260364-38dd044c51fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwyfHxmaXRuZXNzJTIwYW5hdG9teSUyMDNkJTIwbW9kZWx8ZW58MHx8fHwxNzgzOTg4MjQ5fDA&ixlib=rb-4.1.0&q=85",
  coaching:
    "https://images.unsplash.com/photo-1676655079738-af54dfd6318e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxkYXJrJTIwZ3ltJTIwc3BvdGxpZ2h0JTIwYXRobGV0ZXxlbnwwfHx8fDE3ODM5ODgyNDl8MA&ixlib=rb-4.1.0&q=85",
  workMagenxx: "/work/magenxx.jpg",
  workPrime: "/work/prime-improvements.webp",
  workMakeup: "/work/makeupsexx.jpg",
  workFierce: "/work/fierce-flawless.jpg",
  workBrands: "/work/brands.jpg",
};

export const PROFILE = {
  name: "Scott Whitty",
  logo: "SCOTT WHITTY",
  studio: "Phocion Technologies",
  role: "Digital Product & Visual Designer",
  location: "Sydney, Nova Scotia",
  email: "scott_whitty@hotmail.com",
  linkedin: "https://linkedin.com/in/scott-whitty-8b47b1aa",
  resumeUrl: "/Scott_Whitty_Resume.pdf",
  years: "20+",
  heroLines: ["DESIGN.", "BRAND.", "BUILD."],
  capabilityLine: "Product Design · UI/UX · WordPress · Brand Systems · Creative Technology",
  intro:
    "I turn complex ideas into clear digital products, interfaces, websites and visual systems — combining more than 20 years of design experience with hands-on product thinking and execution.",
  status: "Open to new roles & freelance projects",
};

// Runs in the editorial marquee — what I do.
export const SERVICES = [
  "PRODUCT DESIGN",
  "UI / UX",
  "WORDPRESS",
  "E-COMMERCE",
  "BRAND SYSTEMS",
  "CREATIVE TECHNOLOGY",
];

// "How I work" — four principles.
export const MANIFESTO = [
  {
    no: "01",
    title: "Systems Thinking",
    body: "I see the whole picture, not isolated screens. I map user flows, structure content and turn tangled requirements into a clear, buildable plan.",
  },
  {
    no: "02",
    title: "Product Vision",
    body: "I can imagine an experience before it exists — then translate it into interfaces, roadmaps and assets a team can actually ship.",
  },
  {
    no: "03",
    title: "Craft You Can Feel",
    body: "More than twenty years in Photoshop and on the web have made me relentless about sharpness, spacing, composition and brand consistency.",
  },
  {
    no: "04",
    title: "Execution",
    body: "A concept only creates value when it can be built. I design with real content, technical limitations, team capabilities and delivery requirements in mind.",
  },
];

// 12 skills, numbered.
export const SKILLS = [
  "Product Architecture",
  "Systems Thinking",
  "UI/UX Design",
  "WordPress & CMS",
  "E-Commerce",
  "Adobe Photoshop",
  "Brand & Visual Systems",
  "Product Requirements & Workflow Mapping",
  "Knowledge Engineering",
  "Technical Documentation",
  "AI-Assisted Creative Workflows",
  "Cross-Functional Collaboration",
];

export const ADDITIONAL_EXPERIENCE =
  "Entrepreneurship · Licensing & IP Documentation · Business Presentations · Partner Materials";

export const TOOLS = [
  "Adobe Photoshop CC",
  "WordPress & CMS",
  "E-Commerce",
  "AI Image & Content Tools",
  "Blender / 3D Workflows",
  "Unity Asset Collaboration",
];

// Selected projects — each with a real visual preview.
export const WORK = [
  {
    slug: "magenxx",
    no: "/01",
    title: "MAGENXX",
    label: "AI-ASSISTED BIOMECHANICS PLATFORM",
    role: "Lead Product Designer & Architect",
    year: "2015—NOW",
    desc: "Product architecture, UI/UX, brand systems, WordPress development and 3D visualization for an AI-assisted biomechanics platform.",
    tags: ["Product Design", "UI/UX", "Brand Systems", "WordPress"],
    img: IMAGES.workMagenxx,
    accent: "#FF3333",
    featured: true,
    href: "#casestudy",
    cta: "Read case study",
  },
  {
    slug: "prime-improvements",
    no: "/02",
    title: "Prime Improvements",
    label: "RENOVATION COMPANY",
    role: "Website & Brand",
    year: "2019",
    desc: "Website design, brand presentation and local-service positioning for a GTA and Niagara renovation company.",
    tags: ["Web Design", "Branding", "WordPress"],
    img: IMAGES.workPrime,
    accent: "#F5B841",
    url: "https://primeimprovements.ca",
    cta: "Visit site",
  },
  {
    slug: "makeupsexx",
    no: "/03",
    title: "MakeupSexx",
    label: "COSMETICS BRAND",
    role: "Brand & E-Commerce",
    year: "2020",
    desc: "Cosmetics brand identity, e-commerce design and digital product presentation.",
    tags: ["Cosmetics", "Branding", "E-Commerce"],
    img: IMAGES.workMakeup,
    accent: "#E85D9E",
    highlightLabel: true,
    cta: "Coming soon",
  },
  {
    slug: "fierce-flawless",
    no: "/04",
    title: "Fierce & Flawless",
    label: "FASHION BRAND",
    role: "Brand & Web",
    year: "2021",
    desc: "Fashion brand identity, marketing visuals and web presentation.",
    tags: ["Fashion", "Branding", "Web"],
    img: IMAGES.workFierce,
    accent: "#6C7BF2",
    cta: "Coming soon",
  },
  {
    slug: "selected-brands",
    no: "/05",
    title: "Selected Brand & Startup Work",
    label: "IDENTITIES · CAMPAIGNS · CONCEPTS",
    role: "Branding & Web Design",
    year: "ONGOING",
    desc: "Selected identities, campaigns, websites and early-stage business concepts.",
    tags: ["Branding", "Web Design", "Startups"],
    img: IMAGES.workBrands,
    accent: "#3FBF8F",
    cta: "Available on request",
  },
];

// MAGENXX case study.
export const CASE_STUDY = {
  eyebrow: "/ Flagship Case Study",
  title: "MAGENXX",
  roleLabel: "Lead Product Designer / Product Architect",
  years: "2015—Present",
  intro:
    "Since 2015, I have led product design, visual systems and digital product architecture for MAGENXX — translating complex biomechanical expertise into clear user workflows, interfaces, websites, documentation, educational materials and partner communications.",
  summary: [
    {
      label: "The Challenge",
      body: "Translate a complex biomechanics and neuro-orientation methodology into a clear, usable digital product.",
    },
    {
      label: "My Role",
      body: "Lead product designer and product architect responsible for workflows, UI/UX, visual systems, websites, documentation and 3D direction.",
    },
    {
      label: "Key Deliverables",
      body: "Assessment flows, client onboarding, product screens, WordPress platforms, MAGENXX Studio, educational materials, pitch decks and brand systems.",
    },
  ],
  process: ["Research", "Structure", "Prototype", "Design", "Build", "Refine"],
  contributions: [
    {
      index: "01",
      title: "Product & UX Design",
      desc: "Defined flows for trainer assessments, client onboarding, exercise selection, AI-assisted recommendations and progress tracking.",
      img: IMAGES.software,
      span: "lg:col-span-7",
      tall: true,
    },
    {
      index: "02",
      title: "Brand & Visual Direction",
      desc: "Led identity, marketing imagery, presentation assets and 3D visualization concepts for education and demos.",
      img: IMAGES.coaching,
      span: "lg:col-span-5",
      tall: true,
    },
    {
      index: "03",
      title: "WordPress & Web Build",
      desc: "Built public sites, landing pages, e-commerce concepts and the MAGENXX Studio knowledge-authoring environment.",
      img: IMAGES.workBrands,
      span: "lg:col-span-4",
      tall: false,
    },
    {
      index: "04",
      title: "Business & IP Materials",
      desc: "Produced pitch decks, funding applications, business plans and organized trademark & intellectual-property documentation.",
      img: IMAGES.scott,
      span: "lg:col-span-4",
      tall: false,
    },
    {
      index: "05",
      title: "Knowledge Engineering & Product Architecture",
      desc: "Organized expert biomechanical knowledge into assessment questions, workflows, rules, content structures and software requirements developers could implement.",
      img: IMAGES.anatomy,
      span: "lg:col-span-4",
      tall: false,
    },
  ],
  outcomes: [
    "Created a unified visual and product language across app, web, education and business materials.",
    "Converted specialist biomechanical knowledge into structured product and development requirements.",
    "Coordinated design work between subject-matter experts, developers, medical reviewers and 3D artists.",
  ],
};
